export enum Groups {
  C3_QUANTILIA = "c3-quantilia",
  C3_USERS = "c3-users",
  C5_QUANTILIA = "c5-quantilia",
  C5_USERS = "c5-users",
  C7_QUANTILIA = "c7-quantilia",
  C7_USERS = "c7-users",
  D1_QUANTILIA = "d1-quantilia",
  D1_USERS = "d1-users",
  E2_QUANTILIA = "e2-quantilia",
  E2_USERS = "e2-users",
  G4_QUANTILIA = "g4-quantilia",
  G4_USERS = "g4-users",
  I1_QUANTILIA = "i1-quantilia",
  I1_USERS = "i1-users",
}
